import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { formatDateShort } from "../../lib/format";

export default function ArticlesAdmin() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const { user } = useAuth();
  const navigate = useNavigate();

  const load = () => {
    const params = { public: false, limit: 200 };
    if (filter !== "all") params.status = filter;
    api.get("/articles", { params }).then(r => setItems(r.data.items || []));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const remove = async (id) => {
    if (!window.confirm("Excluir esta notícia?")) return;
    try { await api.delete(`/articles/${id}`); toast.success("Excluída"); load(); }
    catch (e) { toast.error("Erro ao excluir"); }
  };

  return (
    <AdminLayout>
      <div data-testid="admin-articles">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="font-serif-display text-4xl font-bold">Notícias</h1>
            <p className="font-sans-ui text-sm text-zinc-500">Gerencie matérias publicadas, rascunhos e agendadas</p>
          </div>
          <button onClick={() => navigate("/admin/noticias/nova")} className="bg-red-700 hover:bg-red-600 text-white px-4 py-2 font-sans-ui text-sm uppercase tracking-widest font-semibold flex items-center gap-2" data-testid="new-article-btn">
            <Plus size={14}/> Nova Notícia
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {[
            {k: "all", l: "Todas"},
            {k: "published", l: "Publicadas"},
            {k: "draft", l: "Rascunhos"},
            {k: "scheduled", l: "Agendadas"},
          ].map(t => (
            <button key={t.k} onClick={() => setFilter(t.k)} className={`px-4 py-1.5 font-sans-ui text-xs uppercase tracking-widest border ${filter === t.k ? "bg-black text-white border-black" : "bg-white border-zinc-300"}`} data-testid={`filter-${t.k}`}>
              {t.l}
            </button>
          ))}
        </div>

        <div className="border border-zinc-300 bg-white overflow-x-auto">
          <table className="w-full text-sm font-sans-ui">
            <thead className="bg-zinc-100">
              <tr className="text-left">
                <th className="p-3">Título</th>
                <th className="p-3">Categoria</th>
                <th className="p-3">Autor</th>
                <th className="p-3">Status</th>
                <th className="p-3">Data</th>
                <th className="p-3">Views</th>
                <th className="p-3"></th>
              </tr>
            </thead>
            <tbody>
              {items.map(a => (
                <tr key={a.id} className="border-t border-zinc-200" data-testid={`row-${a.slug}`}>
                  <td className="p-3 font-serif-display font-semibold">{a.title}</td>
                  <td className="p-3 text-zinc-600">{a.category?.name || "-"}</td>
                  <td className="p-3 text-zinc-600">{a.author?.name || "-"}</td>
                  <td className="p-3">
                    <span className={`px-2 py-0.5 text-xs uppercase tracking-widest ${a.status === "published" ? "bg-green-100 text-green-800" : a.status === "scheduled" ? "bg-blue-100 text-blue-800" : "bg-zinc-200 text-zinc-700"}`}>{a.status}</span>
                  </td>
                  <td className="p-3 text-zinc-600">{formatDateShort(a.published_at || a.created_at)}</td>
                  <td className="p-3 text-zinc-600">{a.views || 0}</td>
                  <td className="p-3 flex gap-2">
                    <Link to={`/admin/noticias/${a.id}`} className="p-1.5 border border-zinc-300 hover:bg-zinc-100" data-testid={`edit-${a.slug}`}><Edit2 size={14}/></Link>
                    <button onClick={() => remove(a.id)} className="p-1.5 border border-zinc-300 hover:bg-red-50 text-red-700" data-testid={`delete-${a.slug}`}><Trash2 size={14}/></button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-zinc-500">Nenhuma notícia.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
